class HeroCollection {
	constructor(el) {
		this.textElement = el;

		this.wrapper = el.closest('.hero-collection__text-wrapper');
		this.button = this.wrapper.querySelector('.hero-collection__show-more');
		this.lineClampClass = '_collapsed';

		this.init();
	}

	init() {
		this.textElement.classList.add(this.lineClampClass);

		const updateMoreButtonState = () => {
			const { scrollHeight, clientHeight } = this.textElement;
			const isClamped = scrollHeight > clientHeight + 2;

			this.button.style.display = isClamped ? 'inline-block' : 'none';
		};

		requestAnimationFrame(updateMoreButtonState);

		window.addEventListener('resize', updateMoreButtonState);
	}
}

document.querySelectorAll('[data-hero-collection-text]').forEach((el) => new HeroCollection(el));

export default HeroCollection;
